<template>
  <div class="general-wrapper">
    <Header :parent="editing ? 'menus' : null" v-if="editing">
      <template #title>
        {{ currentMenu.title }}
      </template>
      <!-- <template #parent>
        <span
          class="span-link qrw-heading-xs v1-grey-7-color"
          @click="returnToMenuList(true)"
        >
          {{ $t("menus.title") }}
          <BaseIcon icon="chevron-right" size="sm2" class="v1-grey-10-color" />
        </span>
      </template> -->
      <template #actions>
        <div class="language-controls">
          <CurrentLanguageBar @edit="
      language_modal = true;
    adding_locale = false;
    " @add="
      language_modal = true;
    adding_locale = true;
    " />
        </div>
      </template>
    </Header>

    <Header v-else>
      <template #actions v-if="showPosActions">
        <div class="gap-column-1xs">
          <div class="current-pos-logo">
            <img :src="`https://cdn.qrwaiter.com.ua/assets/integrations/${currentPosSystem}.jpg`" alt="" />
            <span class="qrw-label-sm bold v1-grey-10-color">
              {{ currentPosName }}
            </span>
          </div>

          <BaseDivider vertical color="v1-grey-4" style="height: 32px" />

          <div class="gap-column-zero">
            <BaseButton variant="tertiary" @click="pos_sync_menu = true" size="md" icon="refresh-cw"
              color="v1-grey-10" />
            <BaseButton variant="tertiary" :iconBalloon="new_changes_count > 0 ? 'orange-4' : null" iconPosition="right"
              @click="pos_changelog_menu = true" size="md" icon="timer" color="v1-grey-10" />
          </div>
        </div>
      </template>
    </Header>

    <MenuEditor @return="returnToMenuList(true)" class="pb-0" v-if="editing" />

    <template v-if="!editing">
      <IQOSHorizontalScrollWithActions :elementCount="menus.length" :paddingSize="'sm'" barGap="zero"
        :scrollContainerStyles="{
      'padding': '8px 40px 16px 40px'
    }" autoHeight id="menuListContainer">
        <MenusManager @edit="openMenuEditUI" :current="menu" :rearranging="rearranging" :edit_menu_id="edit_title_id"
          @rearranged="toggleRearrange" @clearEditTitle="edit_title_id = null" ref="menusManager" />

        <template #actions>
          <MenuActionButtons @add="showAddUI" @duplicate="onMenuDuplicate" @edit="openMenuEditUI" @delete="showDeleteUI"
            @rename="onMenuEdit" :renaming="edit_title_id" :canOnlyDelete="cannotEditMenu"
            :allowDuplicate="!currentMenu.is_example" v-if="menus.length" />
        </template>
      </IQOSHorizontalScrollWithActions>
      <BaseDivider color="v1-grey-3" />
      <PageContainer :topPadding="24">
        <MenuSettings :menu="currentMenu" @edit="editing = true" v-if="currentMenu" />
      </PageContainer>
    </template>

    <DangerConfirmModal @cancel="deleting = false" @confirm="onMenuDelete"
      :title="$t('menu_settings.confirm_delete_title')" v-if="deleting">
      <p class="qrw-paragraph-md v1-grey-3-color">
        {{
      $t("menu_settings.confirm_delete", {
        title: currentMenu.title,
      })
    }}
      </p>

      <p class="iqos-comment qrw-paragraph-md mt-16">
        {{ $t("menu_settings.cannot_reverse") }}
      </p>
    </DangerConfirmModal>

    <BusyModal v-if="loading" />

    <UpdatedLanguageModal :exclude="currentMenu.locales.concat([currentMenu.original_locale])"
      @select="onLanguageSelect" @close="language_modal = false"
      :forOriginal="!currentMenu.original_locale || !adding_locale" v-if="language_modal" />

    <portal-target name="white-modal-portal"> </portal-target>

    <MenuPosSyncTooltip @close="pos_sync_menu = false"
      @storageSyncDisabled="pos_sync_menu = false; pos_storage_unhide_popup = true" v-if="pos_sync_menu" />

    <PosPendingChangesTooltip @close="pos_changelog_menu = false" :menu_id="currentMenu._id"
      @newChangesCountUpdated="c => new_changes_count = c" :shown="pos_changelog_menu" v-if="currentMenu" />

    <PosterHiddenLeftoversModal @close="pos_storage_unhide_popup = false; pos_sync_menu = true"
      v-if="pos_storage_unhide_popup" />
  </div>
</template>

<style scoped>
.add-lang-btn {
  border-radius: 50%;
}

.language-controls {
  display: flex;
  align-items: center;
  align-content: center;
}

.span-link {
  display: flex;
  align-items: center;
  align-content: center;
}

.current-pos-logo {
  padding: 8px;
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
}

.current-pos-logo img {
  width: 16px;
  height: 16px;
  display: block;
  max-width: 16px;
  max-height: 16px;
  min-width: 16px;
  border-radius: 2px;
}
</style>

<script>
import MenuActionButtons from '@/components/menu/MenuActionButtons.vue'
import MenuSettings from '@/components/menu/MenuSettings.vue'
import MenusManager from '@/components/menu/MenusManager.vue'
import MenuEditor from '@/components/menu/MenuEditor.vue'
import SystemsNavigator from '@/components/SystemsNavigator.vue'
import BusyModal from '@/components/modals/BusyModal.vue'

import CurrentLanguageBar from '@/components/menu/CurrentLanguageBar.vue'

import UpdatedLanguageModal from '@/components/modals/UpdatedLanguageModal.vue'

import MenuPosSyncTooltip from '@/components/integrations/MenuPosSyncTooltip.vue'
import PosPendingChangesTooltip from '@/components/integrations/PosPendingChangesTooltip.vue'
import PosterHiddenLeftoversModal from '@/components/integrations/PosterHiddenLeftoversModal.vue'

import MenuAPI from '@/api/menu'

export default {
  components: {
    MenuSettings,
    MenusManager,
    MenuEditor,
    SystemsNavigator,
    UpdatedLanguageModal,
    MenuActionButtons,
    BusyModal,
    CurrentLanguageBar,
    MenuPosSyncTooltip,
    PosPendingChangesTooltip,
    PosterHiddenLeftoversModal
  },

  data () {
    return {
      menu: null,
      editing: false,
      deleting: false,
      rearranging: false,

      loading: true,

      language_modal: false,

      selected_first: false,

      edit_title_id: null,

      new_changes_count: 0,

      pos_sync_menu: false,
      pos_changelog_menu: false,
      pos_storage_unhide_popup: false
    }
  },
  watch: {
    menus () {
      if (this.menus.length && !this.selected_first) {
        this.$store.commit('menu/setCurrentMenu', this.menus[0])
        this.selected_first = true
      }
    },
    $route () {
      if (this.$route.name == 'menus') {
        this.$store.dispatch('menu/save').then(() => {
          this.$store.dispatch('menu/fetchMenus')
        })
        this.editing = false
      }
    }
  },
  methods: {
    onMenuSelect (menu) {
      this.menu = menu
    },
    onMenuEdit () {
      // this.editing = true;
      if (this.edit_title_id) {
        this.$refs.menusManager.onEditMenuTitle()
        return
      }

      this.edit_title_id = this.currentMenu._id

      this.$refs.menusManager.hideAddMenuUI()
    },
    onMenuDuplicate () {
      const new_title = `${this.currentMenu.title} ${this.$t('menu_settings.duplicate_suffix')}`
      this.$store.dispatch('menu/duplicate', {
        menu_id: this.currentMenu._id,
        title: new_title
      })

      this.$store.dispatch('auditlog/write', {
        type: 'menu_duplicate',
        payload: {
          title: this.currentMenu.title
        }
      })
    },
    showDeleteUI () {
      this.deleting = true
    },
    returnToMenuList (dont_save) {
      if (dont_save) {
        this.$store.dispatch('menu/fetchMenus')
      } else {
        this.$store.dispatch('menu/save').then(() => {
          this.$store.dispatch('menu/fetchMenus')
        })
      }
      this.$router.push('/menus')
      this.editing = false
    },
    openMenuEditUI () {
      this.editing = true
      this.$router.replace(`/menus/${this.currentMenu._id}`)

      if (!this.currentMenu.original_locale) {
        this.adding_locale = true
        this.language_modal = true
      }
    },
    onMenuDelete () {
      const title = this.currentMenu.title
      const id = this.currentMenu._id

      if (this.$store.state.selected_chain) {
        this.$store.commit('removeMenuFromChain', this.currentMenu._id)
        this.$store.dispatch('saveChain')
      }

      this.$store.commit('removeMenuFromModes', this.currentMenu._id)
      this.$store.commit('removePosterMenu', this.currentMenu._id)
      this.$store.dispatch('saveCafe')

      this.deleting = false

      this.$store.dispatch('auditlog/write', {
        type: 'menu_delete',
        payload: {
          id: this.currentMenu._id,
          title: this.currentMenu.title
        }
      })

      this.$store.dispatch('menu/remove', this.currentMenu._id)

      if (this.menus.length - 1 > 0) {
        const index = this.menus.findIndex(m => m._id == this.currentMenu._id)

        this.$store.commit('menu/setCurrentMenu', this.menus[index == 0 ? 0 : index - 1])
      } else {
        this.$store.commit('menu/setCurrentMenu', null)
      }
    },
    toggleRearrange () {
      MenuAPI.rearrange(
        this.menus.map(m => {
          return {
            menu_id: m._id,
            group_id: m.group_id
          }
        })
      )
    },
    onLanguageSelect (locales) {
      this.language_modal = false

      const first = locales[0]

      if (!this.currentMenu.original_locale) {
        this.$store.commit('menu/setOriginalLocale', first)
        this.adding_locale = false
      } else if (this.adding_locale) {
        for (const l of locales) {
          this.$store.commit('menu/addLocale', l)
        }
      } else {
        this.$store.commit('menu/setOriginalLocale', first)
      }

      this.$store.dispatch('menu/save')

      if (!this.adding_locale) {
        this.$store.commit('menu/setCurrentLocale', null)
      } else {
        this.$store.commit('menu/setCurrentLocale', first)
        this.$store.commit('menu/postFixModificatorsLocalizations')
      }
    },
    setLocale (v) {
      if (v && this.currentLocale == v) {
        this.showDeleteLocaleUI(v)
        return
      }
      this.$store.commit('menu/setCurrentLocale', v)
      this.$store.commit('menu/postFixModificatorsLocalizations')
    },
    addNewLanguage () {
      this.adding_locale = true
      this.language_modal = true
    },
    showAddUI () {
      this.$refs.menusManager.toggleAddMenuUI(true)
    }
  },
  mounted () {
    this.loading = !this.menus || !this.menus.length
    this.$store
      .dispatch('menu/fetchMenus')
      .then(() => {
        this.loading = false
        const target_id = this.$route.query.sync_menu_id || this.$route.params.id

        if (target_id) {
          const menuIndex = this.menus.findIndex(m => m._id == target_id)

          if (menuIndex != -1) {
            this.$store.commit('menu/setCurrentMenu', this.menus[menuIndex])
            this.editing = true
          }
        }
      })
      .catch(err => {
        this.loading = false
      })

    if (this.$store.getters.hasPosterIntegration) {
      this.$store.dispatch('poster/fetchProductsList')
    }

    if (this.$store.getters.hasIikoIntegration) {
      this.$store.dispatch('iiko/fetchProductsList')
    }
  },
  computed: {
    cafe () {
      return this.$store.state.cafe
    },
    menus () {
      return this.$store.state.menu.menus
    },

    currentMenu () {
      return this.$store.state.menu.current
    },

    currentLocale () {
      return this.$store.state.menu.current_locale
    },

    languageSwitcherModel: {
      get () {
        if (this.currentLocale) return this.currentLocale

        return this.currentMenu.original_locale
      },

      set (v) {
        if (v == this.currentMenu.original_locale) {
          this.$store.commit('menu/setCurrentLocale', null)
        } else {
          this.$store.commit('menu/setCurrentLocale', v)
        }
      }
    },

    cannotEditMenu () {
      if (this.cafe && this.cafe.poster) {
        if (this.cafe.poster.menu_id == this.currentMenu._id) return true
      }

      return false
    },

    panelPadding () {
      return this.editing ? '4vh' : '5.6vh'
    },

    editing: {
      get () {
        return this.$store.state.menu.is_editing
      },
      set (v) {
        this.$store.commit('menu/setEditing', v)
      }
    },

    menuLanguages () {
      return this.currentMenu.locales.map(it => {
        return {
          name: it,
          isFilled: false
        }
      })
    },

    showActions () {
      return !!this.$store.state.menu.current && !this.editing
    },

    showPosActions () {
      return this.$store.getters.currentPosSystem == 'poster' && this.menus.length
    },

    currentPosSystem () {
      return this.$store.getters.currentPosSystem
    },

    currentPosName () {
      return (
        {
          poster: 'Poster',
          iiko: 'iiko'
        }[this.currentPosSystem] || 'n/a'
      )
    }
  }
}
</script>
